/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, Delegate_$type, runOn, delegateCombine, fromEnum, typeCast, Array_$type, delegateRemove, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, enumGetBox, String_$type } from "igniteui-react-core";
import { Popup } from "igniteui-react-layouts";
import { Suffix } from "igniteui-react-inputs";
import { InputGroup } from "igniteui-react-inputs";
import { Label } from "igniteui-react-inputs";
import { Input } from "igniteui-react-inputs";
import { List$1 } from "igniteui-react-core";
import { Icon } from "igniteui-react-inputs";
import { GridCellPosition } from "./GridCellPosition";
import { GotFocusEventArgs } from "./GotFocusEventArgs";
import { LostFocusEventArgs } from "./LostFocusEventArgs";
import { FilterFactory } from "igniteui-react-core";
import { ColumnComparisonFilterCondition } from "./ColumnComparisonFilterCondition";
import { NativeUI } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { MultiColumnComboBoxUtilities } from "./MultiColumnComboBoxUtilities";
import { IDataSourceUpdateNotifier_$type } from "igniteui-react-core";
import { MultipleDataSourceNotifier } from "./MultipleDataSourceNotifier";
import { TextHeaderCellModel } from "./TextHeaderCellModel";
import { CornerRadius } from "igniteui-react-core";
import { stringEmpty, stringIsNullOrEmpty } from "igniteui-react-core";
import { stringFormat } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { Thickness } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { StringComparer } from "igniteui-react-core";
import { ThemeResolver } from "igniteui-react-inputs";
import { MultiColumnComboBoxTextChangedEventArgs } from "./MultiColumnComboBoxTextChangedEventArgs";
import { MultiColumnComboBoxValueChangedEventArgs } from "./MultiColumnComboBoxValueChangedEventArgs";
import { FastReflectionHelper } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var MultiColumnComboBoxView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBoxView, _super);
    function MultiColumnComboBoxView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.z = null;
        _this.ag = null;
        _this.f = null;
        _this.ae = null;
        _this.j = null;
        _this.ad = null;
        _this.i = null;
        _this.af = null;
        _this.k = null;
        _this.h = null;
        _this.ab = null;
        _this.l = null;
        _this.ac = null;
        _this.d = null;
        _this.al = null;
        _this.y = new List$1(Delegate_$type, 0);
        _this.ao = null;
        _this.x = true;
        _this.ak = 0;
        _this.u = false;
        _this.a = null;
        _this.c = 0;
        _this.t = false;
        _this.q = false;
        _this.p = false;
        _this.n = false;
        _this.aj = null;
        _this.ai = null;
        _this.w = false;
        _this.r = false;
        return _this;
    }
    Object.defineProperty(MultiColumnComboBoxView.prototype, "e", {
        get: function () {
            return this.d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxView.prototype, "v", {
        get: function () {
            return this.ak == 46;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxView.prototype, "m", {
        get: function () {
            return this.l;
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboBoxView.prototype.a4 = function (a) {
        this.ag = a;
        this.bp();
    };
    MultiColumnComboBoxView.prototype.a5 = function (a) {
        this.f = a;
    };
    MultiColumnComboBoxView.prototype.bd = function () {
    };
    MultiColumnComboBoxView.prototype.bp = function () {
        this.ac = this.z.createElement("div");
        this.cc();
        this.at();
        this.as();
        this.ag.append(this.ae);
        this.b6();
        this.b7();
        document.addEventListener("click", runOn(this, this.au), false);
        window.addEventListener("resize", runOn(this, this.ci), false);
    };
    MultiColumnComboBoxView.prototype.ap = function (a) {
        var b = this.g.m();
        if (null == b) {
            return;
        }
        this.n = false;
        if (b.eo != a) {
            b.eo = a;
            this.n = true;
        }
        else {
            this.av();
        }
    };
    MultiColumnComboBoxView.prototype.aq = function () {
        var a = this.e;
        a.cu = null;
    };
    MultiColumnComboBoxView.prototype.ar = function () {
        var a = this.m;
        if (null != a) {
            a.ac();
        }
        this.b7();
    };
    MultiColumnComboBoxView.prototype.s = function (a) {
        if (null == a) {
            return false;
        }
        var b = this.ae.getNativeElement();
        var c = this.ac.getNativeElement();
        var d = this.ai.getNativeElement();
        return b.contains(a) || c.contains(a) || d.contains(a);
    };
    MultiColumnComboBoxView.prototype.as = function () {
        var a = this.aa;
        var b = this.g;
        this.ae = a.createElement("div");
        this.ae.setStyleProperty("display", "flex");
        this.ae.setStyleProperty("height", "100%");
        this.ae.setAttribute("tabIndex", "0");
        this.ae.setAttribute("outline", "none !important");
        this.ae.listen("focusin", runOn(this, this.ba));
        this.ae.listen("focusout", runOn(this, this.bb));
        var c = a.getSubRenderer(this.ae);
        this.j = new InputGroup();
        this.j.provideContainer(c);
        this.j.j = 2;
        this.af = a.createElement("div");
        var d = a.getSubRenderer(this.af);
        this.k = new Label();
        this.k.provideContainer(d);
        if (this.f.actualLabelVisible) {
            this.cf();
        }
        this.ad = a.createElement("div");
        this.ad.addClass("ig-input");
        this.ad.setRawStyleProperty("flex-grow", "1");
        var e = a.getSubRenderer(this.ad);
        this.i = new Input();
        this.i.provideContainer(e);
        a.getExternal(this.i, a.rootWrapper, a.getExternal(b, null, null));
        this.i.bq = "text";
        this.i.b4 = b.eq;
        var f = this.i;
        f.changing = delegateCombine(f.changing, runOn(this, this.a6));
        var g = this.i;
        g.compositionEnd = delegateCombine(g.compositionEnd, runOn(this, this.a7));
        var h = this.i;
        h.keyDown = delegateCombine(h.keyDown, runOn(this, this.a9));
        var i = this.i;
        i.gotFocus = delegateCombine(i.gotFocus, runOn(this, this.a8));
        this.j.appendContentChild(this.ad);
        this.j.inputs.add(this.i);
        var j = a.createElement("div");
        var k = a.getSubRenderer(j);
        var l = new Suffix();
        l.provideContainer(k);
        this.ab = a.createElement("div");
        this.h = new Icon();
        var m = a.getSubRenderer(this.ab);
        this.h.provideContainer(m);
        this.h.svgPath = MultiColumnComboBoxView.an;
        l.appendContentChild(this.ab);
        this.j.appendContentChild(j);
        this.j.inputs.add(l);
        this.ab.listen("click", runOn(this, this.aw));
    };
    MultiColumnComboBoxView.prototype.at = function () {
        var a = this.z.createElement("div");
        var b = this.z.getSubRenderer(a);
        this.l = new Popup();
        this.l.provideRenderer(b);
        this.ai = this.z.createElement("div");
        this.ai.setStyleProperty("padding", "4px");
        this.ai.setStyleProperty("white-space", "nowrap");
        this.aj = this.z.createElement("div");
        this.aj.append(this.ai);
        this.aj.append(this.ac);
        this.l.appendPopupContent(this.aj);
    };
    MultiColumnComboBoxView.prototype.bh = function (a, b) {
    };
    MultiColumnComboBoxView.prototype.bk = function (a, b, c) {
    };
    MultiColumnComboBoxView.prototype.bg = function () {
        switch (this.c) {
            case 2:
            case 1:
                if (null == this.a) {
                    this.c = 0;
                }
                break;
        }
        var a = null;
        switch (this.c) {
            case 2:
                {
                    var b = this.a.actualCount;
                    if (b == 0) {
                        this.g.co = null;
                    }
                    else {
                        if (b > 1) {
                        }
                        a = this.a.getItemAtIndex(0);
                        var c = this.g.i();
                        var d = new List$1(Base.$, 0);
                        for (var f = 0; f < c.length; f++) {
                            var e = c[f];
                            var g = this.a.getItemProperty(a, e);
                            d.add1(g);
                        }
                        this.g.co = d.count == 1 ? d._inner[0] : d.toArray();
                    }
                }
                break;
            case 1:
                {
                    var h = this.a.actualCount;
                    if (h == 0) {
                        this.g.eq = stringEmpty();
                    }
                    else {
                        if (h > 1) {
                        }
                        var i = this.g.d9();
                        a = this.a.getItemAtIndex(0);
                        var j = this.a.getItemProperty(a, i).toString();
                        this.g.eq = j;
                    }
                    var k = this.b();
                    var l = k.indexOfItem(a);
                    this.b3(l);
                }
                break;
            case 0:
            default: return;
        }
        if (null != a) {
            var m = this.b();
            var n = m.indexOfItem(a);
            this.b3(n);
        }
        this.a.updateNotifier = null;
        this.a = null;
        this.c = 0;
    };
    MultiColumnComboBoxView.prototype.bi = function (a, b) {
    };
    MultiColumnComboBoxView.prototype.bj = function (a, b) {
    };
    MultiColumnComboBoxView.prototype.bn = function (a, b) {
        var c = this.e;
        if (null != c) {
            var d = c.cu;
            if (null != d) {
                if (d.b >= a && d.b <= b) {
                    this.b2(d.b);
                    this.cd();
                }
            }
        }
    };
    MultiColumnComboBoxView.prototype.bs = function (a, b, c) {
    };
    MultiColumnComboBoxView.prototype.bf = function () {
        this.bv();
        if (this.t) {
            var a = this.b();
            var b = a.actualCount;
            if (this.x && b > 0) {
                this.bx();
            }
            else {
                this.by();
            }
        }
        else {
            this.cb();
        }
    };
    MultiColumnComboBoxView.prototype.bo = function (a, b) {
    };
    MultiColumnComboBoxView.prototype.bq = function (a, b) {
    };
    MultiColumnComboBoxView.prototype.av = function () {
        this.cg();
        this.bc();
        var a = this.m;
        if (a.o) {
            return;
        }
        var b = this.cj();
        a.showRelativeToExclusionRect(b, 1, 1);
        this.b7();
    };
    MultiColumnComboBoxView.prototype.cj = function () {
        var a = this.z.rootWrapper.getNativeElement();
        var b = a.getBoundingClientRect();
        ;
        return b;
    };
    MultiColumnComboBoxView.prototype.b = function () {
        var a = this.e;
        if (null != a) {
            return a.actualDataSource;
        }
        return null;
    };
    MultiColumnComboBoxView.prototype.o = function (a) {
        var b = this.d.ad;
        var c = b.count;
        if (0 == c) {
            a = null;
            return {
                ret: true,
                p0: a
            };
        }
        else if (1 == c) {
            a = b._inner[0];
        }
        else {
            a = b._inner[0];
        }
        return {
            ret: null != a,
            p0: a
        };
    };
    MultiColumnComboBoxView.prototype.az = function (a) {
        var b = null != a ? a.b : -1;
        this.b2(b);
    };
    MultiColumnComboBoxView.prototype.a1 = function () {
        var _this = this;
        var a = this.g;
        var b;
        var c = ((function () { var d = _this.o(b); b = d.p0; return d.ret; })());
        if (!c) {
            return;
        }
        a.fc(b);
    };
    MultiColumnComboBoxView.prototype.bc = function () {
        this.m.af();
    };
    MultiColumnComboBoxView.prototype.be = function () {
        var a = this.m;
        if (a.o) {
            this.ar();
            var b = this.i;
            b.b8();
            var c = b.b4.length;
            b.cw(c, c);
        }
    };
    MultiColumnComboBoxView.prototype.bl = function () {
        this.j.ae = true;
        var a = new GotFocusEventArgs();
        this.g.e9(a);
    };
    MultiColumnComboBoxView.prototype.bm = function () {
        this.ar();
        this.j.mb();
        var a = new LostFocusEventArgs();
        this.g.fa(a);
    };
    MultiColumnComboBoxView.prototype.br = function (a) {
        var e_1, _a;
        if (a == null) {
            this.z = null;
            try {
                for (var _b = tslib_1.__values(fromEnum(this.y)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var b = _c.value;
                    b();
                }
            }
            catch (e_1_1) {
                e_1 = { error: e_1_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_1)
                        throw e_1.error;
                }
            }
            this.y.clear();
            return;
        }
        this.z = a;
        var c = a.rootWrapper;
        this.a4(c);
    };
    MultiColumnComboBoxView.prototype.bt = function (a, b) {
        var c = this.b();
        if (null == c) {
            return;
        }
        if (null != this.a) {
            if (a != this.c) {
            }
            this.a.updateNotifier = null;
            this.a = null;
        }
        this.c = a;
        var d = new FilterFactory();
        var e = null;
        var f = null;
        switch (a) {
            case 2:
                {
                    var g = this.g.d9();
                    if (stringIsNullOrEmpty(g)) {
                        return;
                    }
                    e = b.toString();
                    var h = d.property(g);
                    f = h.isEqualTo(e);
                }
                break;
            case 1:
                {
                    var i = this.g.i();
                    if (i.length < 1) {
                        return;
                    }
                    var j = typeCast(Array_$type, b) !== null ? b : [b];
                    if (i.length != j.length) {
                        return;
                    }
                    for (var k = 0; k < i.length; k++) {
                        var l = i[k];
                        e = j[k];
                        var m = d.property(l);
                        var n = m.isEqualTo(e);
                        if (null == f) {
                            f = n;
                        }
                        else {
                            f.and(n);
                        }
                    }
                }
                break;
            case 0:
            default: return;
        }
        this.a = c.clone();
        this.a.filterExpressions.clear();
        this.a.updateNotifier = new MultiColumnComboBoxDataSourceNotificationHandler(this, true);
        this.a.filterExpressions.add(f);
        if (!this.a.isVirtual) {
            this.a.flushAutoRefresh();
        }
    };
    MultiColumnComboBoxView.prototype.bu = function () {
        this.b9();
        var a = this.f.eq;
        var b = this.ao.length;
        var c = !stringIsNullOrEmpty(a) ? a.length : 0;
        if (this.u && !stringIsNullOrEmpty(this.ao) && b > 0) {
            b--;
        }
        this.i.cw(b, c);
    };
    MultiColumnComboBoxView.prototype.bv = function () {
        if (this.n) {
            this.n = false;
            this.av();
        }
    };
    MultiColumnComboBoxView.prototype.bw = function (a) {
        this.ao = a;
        this.x = !this.v;
        this.bz();
    };
    MultiColumnComboBoxView.prototype.bx = function () {
        if (stringIsNullOrEmpty(this.ao)) {
            this.aq();
        }
        else {
            this.b3(0);
        }
        this.bu();
        this.av();
        this.t = false;
    };
    MultiColumnComboBoxView.prototype.by = function () {
        var a = this.d;
        a.selectedItemsChanged = delegateRemove(a.selectedItemsChanged, runOn(this, this.a2));
        try {
            this.e.cu = null;
            this.g.fj(this.ao);
        }
        finally {
            var b = this.d;
            b.selectedItemsChanged = delegateCombine(b.selectedItemsChanged, runOn(this, this.a2));
        }
        this.t = false;
    };
    MultiColumnComboBoxView.prototype.bz = function () {
        var a = this.g.m();
        if (null == a) {
            return;
        }
        this.t = true;
        if (stringIsNullOrEmpty(this.ao)) {
            if (null != a.eo) {
                this.ap(null);
            }
            else {
                this.by();
            }
        }
        else {
            var b = new ColumnComparisonFilterCondition();
            b.e = 11;
            b.j = this.ao;
            b.g = false;
            this.ap(b);
        }
    };
    MultiColumnComboBoxView.prototype.b0 = function () {
        this.ak = 0;
        this.u = false;
    };
    MultiColumnComboBoxView.prototype.b2 = function (a) {
        var b = this.b();
        var c = b.isPlaceholderItem(a);
        if (c) {
        }
        else {
            var d = this.e;
            if (a < 0) {
                this.q = false;
                d.ad.clear();
                if (!this.q) {
                    this.a1();
                }
                return;
            }
            d.selectedItemsChanged = delegateRemove(d.selectedItemsChanged, runOn(this, this.a2));
            try {
                d.ad.clear();
            }
            finally {
                d.selectedItemsChanged = delegateCombine(d.selectedItemsChanged, runOn(this, this.a2));
            }
            if (a >= 0) {
                var e = b.getItemAtIndex(a);
                this.q = false;
                d.ad.add1(e);
                if (!this.q) {
                    this.a1();
                }
            }
        }
    };
    MultiColumnComboBoxView.prototype.b3 = function (a) {
        var b = this.e;
        if (-1 == a) {
            b.cu = null;
            return;
        }
        var c = b.cu;
        var d = new GridCellPosition();
        var e;
        if (null != c) {
            e = c.d;
        }
        else {
            var f = this.g;
            var g = this.g.m();
            e = g.hz();
        }
        d.d = e;
        d.b = a;
        this.p = false;
        b.cu = d;
        if (!this.p) {
            this.az(b.cu);
        }
        this.cd();
    };
    MultiColumnComboBoxView.prototype.b5 = function (a) {
        this.bt(2, a);
    };
    MultiColumnComboBoxView.prototype.b4 = function (a) {
        this.bt(1, a);
    };
    MultiColumnComboBoxView.prototype.b6 = function () {
        var a = this.g;
        if (null != this.j) {
            this.j.h = a.density;
            this.j.d = a.v;
            this.j.op = a.gc;
            this.j.oq = a.gd;
            this.j.cq = a.bo;
            this.j.ta = a.g8;
            this.j.mu = a.fp;
            this.j.h = a.aa;
            this.j.sh = a.ge;
            this.j.g8 = a.bp;
            this.j.si = a.gf;
            this.j.g9 = a.bq;
            this.j.ha = a.br;
            this.j.sj = a.gg;
            this.j.hb = a.bs;
            this.j.hc = a.bt;
            this.j.sy = a.gk;
            this.j.hx = a.bu;
            this.j.sz = a.gl;
            this.j.hy = a.bv;
            this.j.hz = a.bw;
            this.j.h0 = a.bx;
        }
        if (null != this.i) {
            this.i.db = a.gj;
            this.i.aa = a.al;
        }
        if (null != this.k) {
            this.k.text = a.ee;
            this.k.c6 = a.gh;
            this.k.x = a.aj;
        }
        if (null != this.ai) {
            NativeUI.n(this.ai, a.gi);
            if (null != a.ak) {
                this.ai.setStyleProperty("font", a.ak.fontString);
            }
            this.ai.setRawText(a.actualNoMatchesFoundLabel);
            this.bc();
        }
        if (null != this.d) {
            this.d.e8 = a.density;
            var b = a.columnHeadersVisible;
            this.d.kp = b ? -1 : 0;
            this.d.ky = a.rowSeparatorsVisible ? 1 : 0;
        }
        if (null != this.ab) {
            var c = a.dropDownButtonVisible;
            MultiColumnComboBoxUtilities.c(this.ab, c);
        }
    };
    MultiColumnComboBoxView.prototype.b9 = function () {
        var a = this.f.eq;
        this.i.b4 = a;
    };
    MultiColumnComboBoxView.prototype.b7 = function () {
        var a = this.m;
        var b = null != a ? a.o : false;
        this.h.svgPath = b ? MultiColumnComboBoxView.am : MultiColumnComboBoxView.an;
    };
    MultiColumnComboBoxView.prototype.b8 = function () {
        var e_2, _a;
        var a = this.d.j3 + 3;
        var b = this.d.j4 + this.d.ky;
        var c = this.d.actualDataSource;
        var d = null != c ? c.actualCount : 0;
        if (d > 8) {
            d = 8;
        }
        var e = d * b;
        e += a;
        var f = stringFormat("{0}px", e);
        this.ac.setStyleProperty("height", f);
        var g = 0;
        try {
            for (var _b = tslib_1.__values(fromEnum(this.d.actualColumns)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                var i = h.width;
                g += null != i ? i.f : 100;
            }
        }
        catch (e_2_1) {
            e_2 = { error: e_2_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_2)
                    throw e_2.error;
            }
        }
        var j = stringFormat("{0}px", g);
        this.ac.setStyleProperty("width", j);
        if (null != this.ai) {
            var k = this.g;
            var l = MultiColumnComboBoxUtilities.e(this.aa, k.actualNoMatchesFoundLabel, k.aj);
            var m = l.width;
            var n = l.height;
            var o = stringFormat("{0}px", m);
            var p = stringFormat("{0}px", n);
            this.ai.setStyleProperty("width", o);
            this.ai.setStyleProperty("height", p);
        }
    };
    MultiColumnComboBoxView.prototype.ca = function () {
        if (this.t) {
            return;
        }
        this.ao = null;
        var a = this.g.m();
        if (null != a) {
            var b = a.eo;
            if (null != b) {
                a.eo = null;
            }
            else {
                this.cb();
            }
        }
    };
    MultiColumnComboBoxView.prototype.cb = function () {
        var a = this.g;
        if (null != a.co) {
            var b = this.g.co;
            var c = typeCast(Array_$type, b) !== null ? b : [b];
            var d = this.b();
            var e = d.indexOfKey(c);
            if (-1 != e) {
                this.b3(e);
            }
        }
    };
    MultiColumnComboBoxView.prototype.cc = function () {
        var _this = this;
        if (null == this.d) {
            this.z.getPortal(this.ac, "DataGrid", function (a) {
                _this.al = a.componentRef;
                _this.al.height = '100%';
                _this.al.width = '100%';
                _this.d = (_this.al.i);
                _this.ce();
                _this.d.dn = 1;
                _this.d.dl = 0;
                _this.d.ch = 1;
                _this.d.cf = 0;
                _this.d.hb = false;
                _this.d.g2 = false;
                _this.d.sw = new CornerRadius(0, 0);
                var b = _this.d;
                b.activeCellChanged = delegateCombine(b.activeCellChanged, runOn(_this, _this.ay));
                var c = _this.d;
                c.selectedItemsChanged = delegateCombine(c.selectedItemsChanged, runOn(_this, _this.a2));
                var d = _this.d;
                d.cellClicked = delegateCombine(d.cellClicked, runOn(_this, _this.a0));
                var e = _this.d;
                e.sizeChanged = delegateCombine(e.sizeChanged, runOn(_this, _this.a3));
                _this.b6();
            }, false);
        }
    };
    MultiColumnComboBoxView.prototype.cd = function () {
        if (!this.r) {
            return;
        }
        var a = this.d;
        var b = a.cu;
        if (null != b) {
            var c = this.b();
            if (null != c) {
                var d = c.getItemAtIndex(b.b);
                if (null == d) {
                    return;
                }
                a.id(d);
            }
        }
        else {
            a.r6(0);
        }
    };
    MultiColumnComboBoxView.prototype.ce = function () {
        if (null != this.al) {
            var a = this.g;
            var b = a.itemsSource;
            this.d.ad.clear();
            this.al.dataSource = b;
            this.al.autoGenerateDesiredProperties = a.f;
            this.d.l = a.i();
            var c = this.b();
            if (null != c) {
                var d = c.updateNotifier;
                var e = new MultiColumnComboBoxDataSourceNotificationHandler(this, false);
                var f = new MultipleDataSourceNotifier(1, [d, e]);
                c.updateNotifier = f;
                c.propertiesRequested = a.g;
            }
            this.a = null;
        }
    };
    MultiColumnComboBoxView.prototype.cf = function () {
        if (null != this.af) {
            var a = this.f.actualLabelVisible;
            if (a) {
                this.j.appendContentChild(this.af);
                this.j.inputs.add(this.k);
            }
            else {
                this.j.ma(this.af);
                this.j.inputs.remove(this.k);
            }
        }
    };
    MultiColumnComboBoxView.prototype.cg = function () {
        this.b8();
        if (!this.t) {
            this.w = false;
        }
        else {
            var a = this.b();
            this.w = a.actualCount == 0;
        }
        MultiColumnComboBoxUtilities.c(this.ai, this.w);
        MultiColumnComboBoxUtilities.c(this.ac, !this.w);
    };
    MultiColumnComboBoxView.prototype.ax = function () {
        if (this.i != null) {
            this.i.b8();
        }
    };
    MultiColumnComboBoxView.prototype.b1 = function () {
        if (this.i != null) {
            this.i.cv();
        }
    };
    Object.defineProperty(MultiColumnComboBoxView.prototype, "ah", {
        get: function () {
            return this.ag;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxView.prototype, "g", {
        get: function () {
            return this.f;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBoxView.prototype, "aa", {
        get: function () {
            return this.z;
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboBoxView.prototype.ch = function () {
        if (null != this.ah) {
            this.ah.setStyleProperty("box-sizing", "border-box");
        }
    };
    MultiColumnComboBoxView.prototype.au = function (a) {
        var b = a.target;
        if (!this.s(b)) {
            this.bm();
        }
    };
    MultiColumnComboBoxView.prototype.aw = function (a) {
        var b = this.m;
        if (b.o) {
            this.ar();
        }
        else {
            this.ap(null);
        }
        if (null != this.i) {
            this.i.b8();
            this.i.cv();
        }
    };
    MultiColumnComboBoxView.prototype.ay = function (a, b) {
        var c = b.newActiveCell;
        this.az(c);
        this.p = true;
    };
    MultiColumnComboBoxView.prototype.a0 = function (a, b) {
        if (typeCast(TextHeaderCellModel.$, b.cellInfo) !== null) {
            return;
        }
        this.be();
    };
    MultiColumnComboBoxView.prototype.a2 = function (a, b) {
        this.a1();
        this.q = true;
    };
    MultiColumnComboBoxView.prototype.a3 = function (a, b) {
        this.r = b.b != 0 && b.a != 0;
        this.cd();
    };
    MultiColumnComboBoxView.prototype.a6 = function (a, b) {
        if (b.isCompositionInProgress) {
            return;
        }
        var c = b.value;
        this.bw(c);
    };
    MultiColumnComboBoxView.prototype.a7 = function (a, b) {
        var c = this.i.b4;
        this.bw(c);
    };
    MultiColumnComboBoxView.prototype.a8 = function (a, b) {
        this.b0();
    };
    MultiColumnComboBoxView.prototype.a9 = function (a, b) {
        var c = b.keyCode;
        this.ak = c;
        this.u = false;
        var d = b.modifiers;
        switch (c) {
            case 8:
                var e = this.i.selectionStart;
                if (0 == e) {
                    break;
                }
                var f = this.i.b4;
                if (stringIsNullOrEmpty(f)) {
                    break;
                }
                var g = f.length;
                var h = this.i.selectionEnd;
                var i = h - e;
                if (i > 0 && i < g && h == g) {
                    this.u = true;
                }
                break;
            case 40:
                if (d == 1) {
                    this.av();
                    this.ca();
                    b.preventDefault();
                }
                else {
                    var j = this.e;
                    if (null == j) {
                        return;
                    }
                    var k = this.e.cu;
                    if (null != j.cu) {
                        this.d.hu(false, false);
                        b.preventDefault();
                    }
                    else {
                        var l = this.b();
                        if (null != l) {
                            var m = l.actualCount;
                            if (m > 0) {
                                this.b3(0);
                                b.preventDefault();
                            }
                        }
                    }
                }
                break;
            case 38:
                if (d == 1) {
                    this.ar();
                    b.preventDefault();
                }
                else {
                    var n = this.e;
                    if (null == n) {
                        return;
                    }
                    var o = this.e.cu;
                    if (null != n.cu) {
                        this.d.h5(false, false);
                        b.preventDefault();
                    }
                    else {
                        var p = this.b();
                        if (null != p) {
                            var q = p.actualCount;
                            if (q > 0) {
                                this.b3(q - 1);
                                b.preventDefault();
                            }
                        }
                    }
                }
                break;
            case 13:
                this.be();
                break;
            case 27:
                this.ar();
                break;
        }
    };
    MultiColumnComboBoxView.prototype.ba = function (a) {
        this.i.b8();
        var b = (a.originalEvent.relatedTarget);
        if (!this.s(b)) {
            this.bl();
        }
    };
    MultiColumnComboBoxView.prototype.bb = function (a) {
        var b = (a.originalEvent.relatedTarget);
        if (!this.s(b)) {
            this.bm();
        }
    };
    MultiColumnComboBoxView.prototype.ci = function (a) {
        var b = this.m;
        if (null == b || false == b.o) {
            return;
        }
        var c = this.cj();
        this.l.ag(c);
    };
    MultiColumnComboBoxView.$t = markType(MultiColumnComboBoxView, 'MultiColumnComboBoxView');
    MultiColumnComboBoxView.an = "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z";
    MultiColumnComboBoxView.am = "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z";
    return MultiColumnComboBoxView;
}(Base));
export { MultiColumnComboBoxView };
/**
 * @hidden
 */
var MultiColumnComboBoxDataSourceNotificationHandler = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBoxDataSourceNotificationHandler, _super);
    function MultiColumnComboBoxDataSourceNotificationHandler(a, b) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.b = false;
        _this.a = a;
        _this.b = b;
        return _this;
    }
    MultiColumnComboBoxDataSourceNotificationHandler.prototype.rangeActualized = function (a, b) {
        if (!this.b) {
            this.a.bn(a, b);
        }
        else {
            this.a.bh(a, b);
        }
    };
    MultiColumnComboBoxDataSourceNotificationHandler.prototype.notifySetItem = function (a, b, c) {
        if (!this.b) {
            this.a.bs(a, b, c);
        }
        else {
            this.a.bk(a, b, c);
        }
    };
    MultiColumnComboBoxDataSourceNotificationHandler.prototype.notifyClearItems = function () {
        if (!this.b) {
            this.a.bf();
        }
        else {
            this.a.bg();
        }
    };
    MultiColumnComboBoxDataSourceNotificationHandler.prototype.notifyInsertItem = function (a, b) {
        if (!this.b) {
            this.a.bo(a, b);
        }
        else {
            this.a.bi(a, b);
        }
    };
    MultiColumnComboBoxDataSourceNotificationHandler.prototype.notifyRemoveItem = function (a, b) {
        if (!this.b) {
            this.a.bq(a, b);
        }
        else {
            this.a.bj(a, b);
        }
    };
    MultiColumnComboBoxDataSourceNotificationHandler.$t = markType(MultiColumnComboBoxDataSourceNotificationHandler, 'MultiColumnComboBoxDataSourceNotificationHandler', Base.$, [IDataSourceUpdateNotifier_$type]);
    return MultiColumnComboBoxDataSourceNotificationHandler;
}(Base));
export { MultiColumnComboBoxDataSourceNotificationHandler };
/**
 * @hidden
 */
var MultiColumnComboBox = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(MultiColumnComboBox, _super);
    function MultiColumnComboBox() {
        var _this = _super.call(this) || this;
        _this.gq = ThemeResolver.e(InputGroup.c, InputGroup.rx, InputGroup.qh);
        _this.gr = ThemeResolver.e(InputGroup.c, InputGroup.ry, InputGroup.qi);
        _this.b0 = ThemeResolver.b(InputGroup.c, InputGroup.gg, InputGroup.en);
        _this.ha = ThemeResolver.f(InputGroup.c, InputGroup.to, InputGroup.ti);
        _this.fr = ThemeResolver.d(InputGroup.c, InputGroup.m8, InputGroup.m2);
        _this.gs = ThemeResolver.e(InputGroup.c, InputGroup.rz, InputGroup.qj);
        _this.b1 = ThemeResolver.b(InputGroup.c, InputGroup.gh, InputGroup.eo);
        _this.gt = ThemeResolver.e(InputGroup.c, InputGroup.r1, InputGroup.ql);
        _this.b2 = ThemeResolver.b(InputGroup.c, InputGroup.gi, InputGroup.ep);
        _this.b3 = ThemeResolver.b(InputGroup.c, InputGroup.gj, InputGroup.eq);
        _this.gu = ThemeResolver.e(InputGroup.c, InputGroup.r2, InputGroup.qm);
        _this.b4 = ThemeResolver.b(InputGroup.c, InputGroup.gk, InputGroup.er);
        _this.b5 = ThemeResolver.b(InputGroup.c, InputGroup.gl, InputGroup.es);
        _this.gv = ThemeResolver.e(InputGroup.c, InputGroup.r3, InputGroup.qn);
        _this.b6 = ThemeResolver.b(InputGroup.c, InputGroup.gm, InputGroup.et);
        _this.gw = ThemeResolver.e(InputGroup.c, InputGroup.r4, InputGroup.qo);
        _this.b7 = ThemeResolver.b(InputGroup.c, InputGroup.gn, InputGroup.eu);
        _this.b8 = ThemeResolver.b(InputGroup.c, InputGroup.go, InputGroup.ev);
        _this.b9 = ThemeResolver.b(InputGroup.c, InputGroup.gp, InputGroup.ew);
        _this.ao = null;
        _this.s = null;
        _this.b = null;
        _this.f2 = null;
        _this.fs = ThemeResolver.e(InputGroup.c, InputGroup.q3, InputGroup.pn);
        _this.u = 0;
        _this.t = 1;
        _this.f3 = null;
        _this.ft = ThemeResolver.e(InputGroup.c, InputGroup.q4, InputGroup.po);
        _this.be = NaN;
        _this.a4 = ThemeResolver.b(InputGroup.c, InputGroup.fq, InputGroup.dx);
        _this.aw = true;
        _this.at = true;
        _this.g7 = new Thickness(1, NaN, NaN, NaN, NaN);
        _this.g6 = ThemeResolver.f(InputGroup.c, InputGroup.tm, InputGroup.tg);
        _this.fo = new CornerRadius(1, NaN, NaN, NaN, NaN);
        _this.fn = ThemeResolver.d(InputGroup.c, InputGroup.m6, InputGroup.m0);
        _this.c = null;
        _this.z = 0;
        _this.y = 0;
        _this.ay = true;
        _this.f4 = null;
        _this.fu = ThemeResolver.e(InputGroup.c, InputGroup.rl, InputGroup.p5);
        _this.bf = NaN;
        _this.a5 = ThemeResolver.b(InputGroup.c, InputGroup.f1, InputGroup.d8);
        _this.f5 = null;
        _this.fv = ThemeResolver.e(InputGroup.c, InputGroup.rn, InputGroup.p7);
        _this.bg = NaN;
        _this.a6 = ThemeResolver.b(InputGroup.c, InputGroup.f2, InputGroup.d9);
        _this.bh = NaN;
        _this.a7 = ThemeResolver.b(InputGroup.c, InputGroup.f3, InputGroup.ea);
        _this.f6 = null;
        _this.fw = ThemeResolver.e(InputGroup.c, InputGroup.ro, InputGroup.p8);
        _this.bi = NaN;
        _this.a8 = ThemeResolver.b(InputGroup.c, InputGroup.f4, InputGroup.eb);
        _this.bj = NaN;
        _this.a9 = ThemeResolver.b(InputGroup.c, InputGroup.f5, InputGroup.ec);
        _this.cj = null;
        _this.ef = null;
        _this.f7 = null;
        _this.fx = MultiColumnComboBox.go;
        _this.ag = null;
        _this.ad = null;
        _this.a1 = true;
        _this.au = false;
        _this.ek = null;
        _this.da = "No Matches Found";
        _this.f8 = null;
        _this.fy = MultiColumnComboBox.gp;
        _this.ah = null;
        _this.ae = null;
        _this.f9 = MultiColumnComboBox.gx;
        _this.fz = MultiColumnComboBox.gx;
        _this.ai = null;
        _this.af = null;
        _this.ga = null;
        _this.f0 = ThemeResolver.e(InputGroup.c, InputGroup.r5, InputGroup.qp);
        _this.bk = NaN;
        _this.ba = ThemeResolver.b(InputGroup.c, InputGroup.gq, InputGroup.ex);
        _this.gb = null;
        _this.f1 = ThemeResolver.e(InputGroup.c, InputGroup.r6, InputGroup.qq);
        _this.bl = NaN;
        _this.bb = ThemeResolver.b(InputGroup.c, InputGroup.gr, InputGroup.ey);
        _this.bm = NaN;
        _this.bc = ThemeResolver.b(InputGroup.c, InputGroup.gs, InputGroup.ez);
        _this.bn = NaN;
        _this.bd = ThemeResolver.b(InputGroup.c, InputGroup.gt, InputGroup.e0);
        _this.cq = null;
        _this.cp = null;
        _this.d = null;
        _this.a = null;
        _this.ck = null;
        _this.a0 = false;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.textChanged = null;
        _this.valueChanged = null;
        _this.propertyChanged = null;
        var a = _this.r();
        _this.s = a;
        a.a5(_this);
        return _this;
    }
    MultiColumnComboBox.prototype.r = function () {
        return new MultiColumnComboBoxView();
    };
    MultiColumnComboBox.prototype.fg = function (a, b, c) {
        switch (a) {
            case "BackgroundColor":
                this.gc = this.gm != null ? this.gm : this.gq;
                break;
            case "BorderColor":
                this.gd = this.gn != null ? this.gn : this.gr;
                break;
            case "BorderWidth":
                this.bo = !isNaN_(this.by) ? this.by : this.b0;
                break;
            case "ContentPadding":
                this.g8 = InputGroup.s9(this.g9, this.ha);
                break;
            case "CornerRadius":
                this.fp = InputGroup.mt(this.fq, this.fr);
                break;
            case "FocusBorderColor":
                this.ge = this.gy != null ? this.gy : this.gs;
                break;
            case "FocusBorderWidth":
                this.bp = !isNaN_(this.ca) ? this.ca : this.b1;
                break;
            case "FocusUnderlineColor":
                this.gf = this.gz != null ? this.gz : this.gt;
                break;
            case "FocusUnderlineOpacity":
                this.bq = !isNaN_(this.cb) ? this.cb : this.b2;
                break;
            case "FocusUnderlineRippleOpacity":
                this.br = !isNaN_(this.cc) ? this.cc : this.b3;
                break;
            case "HoverUnderlineColor":
                this.gg = this.g0 != null ? this.g0 : this.gu;
                break;
            case "HoverUnderlineOpacity":
                this.bs = !isNaN_(this.cd) ? this.cd : this.b4;
                break;
            case "HoverUnderlineWidth":
                this.bt = !isNaN_(this.ce) ? this.ce : this.b5;
                break;
            case "ItemsSource":
            case "ValueField":
            case "DataSourceDesiredProperties":
            case "AutoGenerateDesiredProperties":
                this.s.ce();
                break;
            case "LabelTextColor":
                this.gh = this.g1 != null ? this.g1 : MultiColumnComboBox.go;
                break;
            case "LabelTextStyle":
                this.aj = this.aq != null ? this.aq : MultiColumnComboBox.am;
                break;
            case "NoMatchesFoundLabelTextColor":
                this.gi = this.g2 != null ? this.g2 : MultiColumnComboBox.gp;
                break;
            case "NoMatchesFoundLabelTextStyle":
                this.ak = this.ar != null ? this.ar : MultiColumnComboBox.an;
                break;
            case "UnderlineColor":
                this.gk = this.g4 != null ? this.g4 : this.gv;
                break;
            case "UnderlineOpacity":
                this.bu = !isNaN_(this.cf) ? this.cf : this.b6;
                break;
            case "UnderlineRippleColor":
                this.gl = this.g5 != null ? this.g5 : this.gw;
                break;
            case "UnderlineRippleOpacity":
                this.bv = !isNaN_(this.cg) ? this.cg : this.b7;
                break;
            case "UnderlineRippleWidth":
                this.bw = !isNaN_(this.ch) ? this.ch : this.b8;
                break;
            case "UnderlineWidth":
                this.bx = !isNaN_(this.ci) ? this.ci : this.b9;
                break;
            case "BaseTheme":
                this.v = this.w == 0 ? 1 : this.w;
                break;
            case "Density":
                this.aa = this.density == 0 ? 0 : this.density;
                break;
            case "TextColor":
                this.gj = this.g3 != null ? this.g3 : MultiColumnComboBox.gx;
                break;
            case "TextStyle":
                this.al = this.as != null ? this.as : null;
                break;
            case "ActualDensity":
            case "ActualBaseTheme":
            case "ActualTextColor":
            case "ActualTextStyle":
            case "ActualBackgroundColor":
            case "ActualBorderColor":
            case "ActualBorderWidth":
            case "ActualContentPadding":
            case "ActualCornerRadius":
            case "ActualFocusBorderColor":
            case "ActualFocusBorderWidth":
            case "ActualFocusUnderlineColor":
            case "ActualFocusUnderlineOpacity":
            case "ActualFocusUnderlineRippleOpacity":
            case "ActualHoverUnderlineColor":
            case "ActualHoverUnderlineOpacity":
            case "ActualHoverUnderlineWidth":
            case "ActualLabelTextColor":
            case "ActualLabelTextStyle":
            case "ActualUnderlineColor":
            case "ActualUnderlineOpacity":
            case "ActualUnderlineRippleColor":
            case "ActualUnderlineRippleOpacity":
            case "ActualUnderlineRippleWidth":
            case "ActualUnderlineWidth":
            case "DropDownButtonVisible":
            case "ColumnHeadersVisible":
            case "RowSeparatorsVisible":
            case "ActualNoMatchesFoundLabel":
            case "ActualNoMatchesFoundLabelTextColor":
            case "ActualNoMatchesFoundLabelTextStyle":
                this.s.b6();
                break;
            case "NoMatchesFoundLabel":
                this.actualNoMatchesFoundLabel = stringIsNullOrEmpty(this.el) ? "No Matches Found" : this.el;
                break;
            case "ActualLabelVisible":
                this.s.cf();
                break;
            case "LabelVisible":
            case "LabelText":
                this.actualLabelVisible = this.a1 ? !stringIsNullOrEmpty(this.ef) : false;
                break;
            case "Text":
                this.s.b9();
                var d = b != null ? b.toString() : null;
                var e = c != null ? c.toString() : null;
                this.fd(new MultiColumnComboBoxTextChangedEventArgs(d, e));
                this.ff(1, e);
                break;
            case "Value":
                this.fe(new MultiColumnComboBoxValueChangedEventArgs(b, c));
                this.ff(0, c);
                break;
        }
    };
    MultiColumnComboBox.prototype.fm = function () {
        this.s.ch();
    };
    Object.defineProperty(MultiColumnComboBox.prototype, "ap", {
        get: function () {
            if (null == this.ao) {
                this.ao = new FontInfo();
                this.ao.n = "'Segoe UI', Verdana";
                this.ao.d = 16;
            }
            return this.ao;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "f", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            if (b != this.b) {
                this.fb("AutoGenerateDesiredProperties", b, this.b);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gm", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            var b = this.f2;
            this.f2 = a;
            if (b != this.f2) {
                this.fb("BackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gc", {
        get: function () {
            return this.fs;
        },
        set: function (a) {
            var b = this.fs;
            this.fs = a;
            if (b != this.fs) {
                this.fb("ActualBackgroundColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "w", {
        get: function () {
            return this.u;
        },
        set: function (a) {
            var b = this.u;
            this.u = a;
            if (b != this.u) {
                this.fb("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "v", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            var b = this.t;
            this.t = a;
            if (b != this.t) {
                this.fb("ActualBaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gn", {
        get: function () {
            return this.f3;
        },
        set: function (a) {
            var b = this.f3;
            this.f3 = a;
            if (b != this.f3) {
                this.fb("BorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gd", {
        get: function () {
            return this.ft;
        },
        set: function (a) {
            var b = this.ft;
            this.ft = a;
            if (b != this.ft) {
                this.fb("ActualBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "by", {
        get: function () {
            return this.be;
        },
        set: function (a) {
            var b = this.be;
            this.be = a;
            if (b != this.be) {
                this.fb("BorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bo", {
        get: function () {
            return this.a4;
        },
        set: function (a) {
            var b = this.a4;
            this.a4 = a;
            if (b != this.a4) {
                this.fb("ActualBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "columnHeadersVisible", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (b != this.aw) {
                this.fb("ColumnHeadersVisible", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "rowSeparatorsVisible", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.fb("RowSeparatorsVisible", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g9", {
        get: function () {
            return this.g7;
        },
        set: function (a) {
            var b = this.g7;
            this.g7 = a;
            if (b != this.g7) {
                this.fb("ContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g8", {
        get: function () {
            return this.g6;
        },
        set: function (a) {
            var b = this.g6;
            this.g6 = a;
            if (b != this.g6) {
                this.fb("ActualContentPadding", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "fq", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            var b = this.fo;
            this.fo = a;
            if (b != this.fo) {
                this.fb("CornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "fp", {
        get: function () {
            return this.fn;
        },
        set: function (a) {
            var b = this.fn;
            this.fn = a;
            if (b != this.fn) {
                this.fb("ActualCornerRadius", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.fb("DataSourceDesiredProperties", b, this.c);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "density", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.fb("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "aa", {
        get: function () {
            return this.y;
        },
        set: function (a) {
            var b = this.y;
            this.y = a;
            if (b != this.y) {
                this.fb("ActualDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "dropDownButtonVisible", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            if (b != this.ay) {
                this.fb("DropDownButtonVisible", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gy", {
        get: function () {
            return this.f4;
        },
        set: function (a) {
            var b = this.f4;
            this.f4 = a;
            if (b != this.f4) {
                this.fb("FocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ge", {
        get: function () {
            return this.fu;
        },
        set: function (a) {
            var b = this.fu;
            this.fu = a;
            if (b != this.fu) {
                this.fb("ActualFocusBorderColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ca", {
        get: function () {
            return this.bf;
        },
        set: function (a) {
            var b = this.bf;
            this.bf = a;
            if (b != this.bf) {
                this.fb("FocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bp", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            if (b != this.a5) {
                this.fb("ActualFocusBorderWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gz", {
        get: function () {
            return this.f5;
        },
        set: function (a) {
            var b = this.f5;
            this.f5 = a;
            if (b != this.f5) {
                this.fb("FocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gf", {
        get: function () {
            return this.fv;
        },
        set: function (a) {
            var b = this.fv;
            this.f5 = a;
            if (b != this.fv) {
                this.fb("ActualFocusUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "cb", {
        get: function () {
            return this.bg;
        },
        set: function (a) {
            var b = this.bg;
            this.bg = a;
            if (b != this.bg) {
                this.fb("FocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bq", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.fb("ActualFocusUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "cc", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            var b = this.bh;
            this.bh = a;
            if (b != this.bh) {
                this.fb("FocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "br", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.fb("ActualFocusUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g0", {
        get: function () {
            return this.f6;
        },
        set: function (a) {
            var b = this.f6;
            this.f6 = a;
            if (b != this.f6) {
                this.fb("HoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gg", {
        get: function () {
            return this.fw;
        },
        set: function (a) {
            var b = this.fw;
            this.fw = a;
            if (b != this.fw) {
                this.fb("ActualHoverUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "cd", {
        get: function () {
            return this.bi;
        },
        set: function (a) {
            var b = this.bi;
            this.bi = a;
            if (b != this.bi) {
                this.fb("HoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bs", {
        get: function () {
            return this.a8;
        },
        set: function (a) {
            var b = this.a8;
            this.a8 = a;
            if (b != this.a8) {
                this.fb("ActualHoverUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ce", {
        get: function () {
            return this.bj;
        },
        set: function (a) {
            var b = this.bj;
            this.bj = a;
            if (b != this.bj) {
                this.fb("HoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bt", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.fb("ActualHoverUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "itemsSource", {
        get: function () {
            return this.cj;
        },
        set: function (a) {
            var b = this.cj;
            this.cj = a;
            if (b != this.cj) {
                this.fb("ItemsSource", b, this.cj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "actualDataSource", {
        get: function () {
            return this.s.b();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ee", {
        get: function () {
            return this.ef;
        },
        set: function (a) {
            var b = this.ee;
            if (0 == StringComparer.b.compare(a, b)) {
                return;
            }
            this.ef = a;
            this.fb("LabelText", b, this.ef);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g1", {
        get: function () {
            return this.f7;
        },
        set: function (a) {
            var b = this.f7;
            this.f7 = a;
            if (b != this.f7) {
                this.fb("LabelTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gh", {
        get: function () {
            return this.fx;
        },
        set: function (a) {
            var b = this.fx;
            this.fx = a;
            if (b != this.fx) {
                this.fb("ActualLabelTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "aq", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.fb("LabelTextStyle", b, this.ag);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "aj", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            var b = this.ad;
            this.ad = a;
            if (this.ad != b) {
                this.fb("ActualLabelTextStyle", b, this.ad);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "labelVisible", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            var b = this.a1;
            this.a1 = a;
            if (b != this.a1) {
                this.fb("LabelVisible", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "actualLabelVisible", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (b != this.au) {
                this.fb("ActualLabelVisible", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "el", {
        get: function () {
            return this.ek;
        },
        set: function (a) {
            var b = this.ek;
            if (0 == StringComparer.b.compare(a, b)) {
                return;
            }
            this.ek = a;
            this.fb("NoMatchesFoundLabel", b, this.ek);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "actualNoMatchesFoundLabel", {
        get: function () {
            return this.da;
        },
        set: function (a) {
            var b = this.da;
            this.da = a;
            if (b != this.da) {
                this.fb("ActualNoMatchesFoundLabel", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g2", {
        get: function () {
            return this.f8;
        },
        set: function (a) {
            var b = this.f8;
            this.f8 = a;
            if (b != this.f8) {
                this.fb("NoMatchesFoundLabelTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gi", {
        get: function () {
            return this.fy;
        },
        set: function (a) {
            var b = this.fy;
            this.fy = a;
            if (b != this.fy) {
                this.fb("ActualNoMatchesFoundLabelTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ar", {
        get: function () {
            return this.ah;
        },
        set: function (a) {
            var b = this.ah;
            this.ah = a;
            if (b != this.ah) {
                this.fb("NoMatchesFoundLabelTextStyle", b, this.ah);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ak", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            var b = this.ae;
            this.ae = a;
            if (this.ae != b) {
                this.fb("ActualNoMatchesFoundLabelTextStyle", b, this.ae);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g3", {
        get: function () {
            return this.f9;
        },
        set: function (a) {
            var b = this.f9;
            this.f9 = a;
            if (b != this.f9) {
                this.fb("TextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gj", {
        get: function () {
            return this.fz;
        },
        set: function (a) {
            var b = this.fz;
            this.fz = a;
            if (b != this.fz) {
                this.fb("ActualTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "as", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.fb("TextStyle", b, this.ai);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "al", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            var b = this.af;
            this.af = a;
            if (this.af != b) {
                this.fb("ActualTextStyle", b, this.af);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g4", {
        get: function () {
            return this.ga;
        },
        set: function (a) {
            var b = this.ga;
            this.ga = a;
            if (b != this.ga) {
                this.fb("UnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gk", {
        get: function () {
            return this.f0;
        },
        set: function (a) {
            var b = this.f0;
            this.f0 = a;
            if (b != this.f0) {
                this.fb("ActualUnderlineColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "cf", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.fb("UnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bu", {
        get: function () {
            return this.ba;
        },
        set: function (a) {
            var b = this.ba;
            this.ba = a;
            if (b != this.ba) {
                this.fb("ActualUnderlineOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "g5", {
        get: function () {
            return this.gb;
        },
        set: function (a) {
            var b = this.gb;
            this.gb = a;
            if (b != this.gb) {
                this.fb("UnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "gl", {
        get: function () {
            return this.f1;
        },
        set: function (a) {
            var b = this.f1;
            this.f1 = a;
            if (b != this.f1) {
                this.fb("ActualUnderlineRippleColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "cg", {
        get: function () {
            return this.bl;
        },
        set: function (a) {
            var b = this.bl;
            this.bl = a;
            if (b != this.bl) {
                this.fb("UnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bv", {
        get: function () {
            return this.bb;
        },
        set: function (a) {
            var b = this.bb;
            this.bb = a;
            if (b != this.bb) {
                this.fb("ActualUnderlineRippleOpacity", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ch", {
        get: function () {
            return this.bm;
        },
        set: function (a) {
            var b = this.bm;
            this.bm = a;
            if (b != this.bm) {
                this.fb("UnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bw", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            var b = this.bc;
            this.bc = a;
            if (b != this.bc) {
                this.fb("ActualUnderlineRippleWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "ci", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.fb("UnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "bx", {
        get: function () {
            return this.bd;
        },
        set: function (a) {
            var b = this.bd;
            this.bd = a;
            if (b != this.bd) {
                this.fb("ActualUnderlineWidth", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "es", {
        get: function () {
            return this.cq;
        },
        set: function (a) {
            var b = this.cq;
            this.cq = a;
            if (b != this.cq) {
                this.fb("TextField", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "eq", {
        get: function () {
            return this.cp;
        },
        set: function (a) {
            var b = this.cp;
            this.cp = a;
            if (b != this.cp) {
                this.fb("Text", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "j", {
        get: function () {
            return this.d;
        },
        set: function (a) {
            var b = this.d;
            this.d = a;
            if (b != this.d) {
                this.fb("ValueField", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "e", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.fb("ActualValueField", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MultiColumnComboBox.prototype, "co", {
        get: function () {
            return this.ck;
        },
        set: function (a) {
            var b = this.ck;
            this.ck = a;
            if (b != this.ck) {
                this.fb("Value", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    MultiColumnComboBox.prototype.cl = function (a, b) {
        var c = new FastReflectionHelper(false, b);
        return c.getPropertyValue(a);
    };
    MultiColumnComboBox.prototype.m = function () {
        var a = this.d9();
        return this.l(a);
    };
    MultiColumnComboBox.prototype.d9 = function () {
        return this.d8(this.es);
    };
    MultiColumnComboBox.prototype.cm = function (a) {
        var b = this.i();
        if (null == b || b.length == 0) {
            return null;
        }
        var c = new List$1(Base.$, 0);
        for (var e = 0; e < b.length; e++) {
            var d = b[e];
            var f = this.cl(a, d);
            c.add1(f);
        }
        if (c.count == 1) {
            return c._inner[0];
        }
        return c.toArray();
    };
    MultiColumnComboBox.prototype.d7 = function (a) {
        var b = this.d9();
        var c = null != b ? this.cl(a, b).toString() : null;
        return c;
    };
    MultiColumnComboBox.prototype.l = function (a) {
        var e_3, _a;
        var b = this.s.e;
        if (null == b) {
            return null;
        }
        var c = b.actualColumns;
        if (null == c || 0 == c.count) {
            return null;
        }
        if (stringIsNullOrEmpty(a)) {
            return c._inner[0];
        }
        try {
            for (var _b = tslib_1.__values(fromEnum(c)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var d = _c.value;
                if (0 == StringComparer.b.compare(d.hx, a)) {
                    return d;
                }
            }
        }
        catch (e_3_1) {
            e_3 = { error: e_3_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_3)
                    throw e_3.error;
            }
        }
        return null;
    };
    MultiColumnComboBox.prototype.d8 = function (a) {
        if (stringIsNullOrEmpty(a)) {
            var b = this.actualDataSource;
            if (null == b) {
                return null;
            }
            var c = b.actualSchema;
            if (null == c) {
                return null;
            }
            var d = c.propertyNames;
            if (0 == d.length) {
                return null;
            }
            return d[0];
        }
        return a;
    };
    MultiColumnComboBox.prototype.h = function (a) {
        var b = new List$1(String_$type, 0);
        if (null == a || a.length == 0) {
            var c = this.d8(null);
            if (stringIsNullOrEmpty(c)) {
                return null;
            }
            b.add(c);
            return b.toArray();
        }
        for (var e = 0; e < a.length; e++) {
            var d = a[e];
            var f = this.d8(d);
            if (null != f) {
                b.add(f);
            }
        }
        if (b.count > 0) {
            return b.toArray();
        }
        return null;
    };
    MultiColumnComboBox.prototype.i = function () {
        var a = this.j;
        return this.h(a);
    };
    MultiColumnComboBox.prototype.fc = function (a) {
        this.ff(2, a);
    };
    MultiColumnComboBox.prototype.ff = function (a, b) {
        if (this.a0) {
            return;
        }
        this.a0 = true;
        try {
            switch (a) {
                case 2:
                    {
                        var c = b;
                        var d = void 0;
                        var e = void 0;
                        if (null != c) {
                            d = this.d7(c);
                            e = this.cm(c);
                        }
                        else {
                            d = stringEmpty();
                            e = null;
                        }
                        this.eq = d;
                        this.co = e;
                    }
                    break;
                case 1:
                    this.s.b5(b.toString());
                    break;
                case 0:
                    this.s.b4(b);
                    break;
            }
        }
        finally {
            this.a0 = false;
        }
    };
    MultiColumnComboBox.prototype.fj = function (a) {
        this.eq = a;
        this.co = null;
    };
    MultiColumnComboBox.prototype.fl = function () {
        this.al = (null == this.as) ? this.ap : this.as;
    };
    MultiColumnComboBox.prototype.fk = function () {
    };
    MultiColumnComboBox.prototype.closeUp = function () {
        this.s.ar();
    };
    MultiColumnComboBox.prototype.destroy = function () {
        this.provideRenderer(null);
    };
    MultiColumnComboBox.prototype.dropDown = function () {
        this.s.av();
    };
    MultiColumnComboBox.prototype.focus = function () {
        this.s.ax();
    };
    MultiColumnComboBox.prototype.select = function () {
        this.s.b1();
    };
    MultiColumnComboBox.prototype.notifySizeChanged = function () {
        this.s.bd();
    };
    MultiColumnComboBox.prototype.provideRenderer = function (a) {
        this.s.br(a);
    };
    MultiColumnComboBox.prototype.e9 = function (a) {
        if (null != this.gotFocus) {
            this.gotFocus(this, a);
        }
    };
    MultiColumnComboBox.prototype.fa = function (a) {
        if (null != this.lostFocus) {
            this.lostFocus(this, a);
        }
    };
    MultiColumnComboBox.prototype.fd = function (a) {
        if (null != this.textChanged) {
            this.textChanged(this, a);
        }
    };
    MultiColumnComboBox.prototype.fe = function (a) {
        if (null != this.valueChanged) {
            this.valueChanged(this, a);
        }
    };
    MultiColumnComboBox.prototype.fb = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.fg(a, b, c);
    };
    MultiColumnComboBox.$t = markType(MultiColumnComboBox, 'MultiColumnComboBox', Base.$, [INotifyPropertyChanged_$type]);
    MultiColumnComboBox.go = ThemeResolver.e(InputGroup.c, Label.c1, Label.cu);
    MultiColumnComboBox.gp = ThemeResolver.e(InputGroup.c, Label.c1, Label.cu);
    MultiColumnComboBox.am = null;
    MultiColumnComboBox.an = null;
    MultiColumnComboBox.gx = BrushUtil.g(221, 0, 0, 0);
    return MultiColumnComboBox;
}(Base));
export { MultiColumnComboBox };
//# sourceMappingURL=MultiColumnComboBoxView_combined.js.map
